
























































































































































import Vue, { PropType } from 'vue';
import { ITableOptions, IHeader } from '@/bundles/BaseTable/interfaces';
import { IAdCampaignItem } from '@/bundles/Ad/interfaces';

interface IBaseTableInstance {
  options: ITableOptions,
  footerOptions: {
    itemsPerPageText: string;
    disableItemsPerPage: boolean;
    itemsPerPageOptions: number[];
    showFirstLastPage: boolean;
  };
  tempSelected: any[];
  showCheckAll: boolean;
}

export default Vue.extend({
  name: 'BaseTable',

  props: {
    tableOptionsEntry: {
      type: Object as PropType<ITableOptions>,
      required: true,
    },
    itemsEntry: {
      type: Array,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    headersDataEntry: {
      type: Array as PropType<IHeader[]>,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/require-default-prop
    tableHeight: Number,
    allowSelect: Boolean,
    loading: Boolean,
    fixedHeaders: Boolean,
    totals: {
      type: Object,
      default: null
    }
  },

  data: (): IBaseTableInstance => ({
    options: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 50,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: [],
      itemsPerPageOptions: [
        { title: '50', value: 50 },
        { title: '100', value: 100 },
        { title: '250', value: 250 },
        { title: '500', value: 500 },
        { title: '750', value: 750 },
        { title: '1000', value: 1000 }
      ]
    },
    footerOptions: {
      itemsPerPageText: '',
      disableItemsPerPage: true,
      itemsPerPageOptions: [10, 25, 100],
      showFirstLastPage: true,
    },
    tempSelected: [],
    showCheckAll: false
  }),

  computed: {
    pageCount: function (): number {
      if (this.totalRowsEntry <= this.options.itemsPerPage) {
        return 1;
      }

      return Math.ceil(this.totalRowsEntry / this.options.itemsPerPage);
    }
  },

  watch: {
    options: {
      handler: function (value: ITableOptions) {
        if (!value.sortBy?.length && value.sortDesc?.length) {
          this.options.sortDesc = [];
          return;
        }
        this.$emit('options:change', value);
      },
      deep: true,
    },
    tableOptionsEntry: {
      handler: function (value) {
        if (JSON.stringify(value) !== JSON.stringify(this.options)) {
          this.options = { ...value };
        }
      },
      deep: true,
    },
    tempSelected: function (val: any) {
      if (val.length !== this.selected.length) this.$emit('changeSelected', val)
    },
  },

  methods: {
    calculateCtr: function (value: any) {
      return parseFloat(value.toString()).toFixed(3);
    },
    generateIconName: function (icon: string, direction: string): string {
      switch (icon) {
        case 'date':
          return `mdi-sort-calendar-${ direction }`;
        case 'string':
          return `mdi-sort-alphabetical-${ direction }-variant`;
        default:
          return `mdi-sort-numeric-${ direction }`;
      }
    },
    isActiveSort: function (item: IHeader): boolean {
      const sortBy = Array.isArray(this.options.sortBy)
        ? this.options.sortBy[0]
        : this.options.sortBy;
      const valueText = item.value;
      return sortBy === valueText;
    },
    setSort: function ({ value, sort }: { value: string; sort: boolean }) {
      this.options = { ...this.options, sortBy: [value], sortDesc: [sort] };
      document.querySelector('.base-table .v-data-table__wrapper')!.scrollTop = 0
    },

    handleDefaultTableSort: function (value: string[]) {
      this.options.sortBy = value;
    },

    handleDefaultTableDescending: function (value: boolean[]) {
      this.options.sortDesc = value;
    },

    onToggleSelectAll: function (event: any) {
      this.showCheckAll = event.value
      const eventName = event.value ? 'changeSelected' : 'uncheckAll';
      this.$emit(eventName, event.items);
    },
    checkAllHandler: function () {
      this.showCheckAll = false
      this.$emit('checkAll')
    }
  },
});
